import { useEffect } from 'react';

import { validateExistingRefereeNames } from '../../../utils/validateExistingRefereeNames';

/**
 * Shared referee-name validation effect used by both NominationReferee and
 * IndependentAssessor collection components. Calls the pure
 * validateExistingRefereeNames helper and pushes the result into RHF via
 * setError/clearErrors. Only touches errors of type 'info' so yup-originated
 * validation errors are preserved.
 */
export const useRefereeValidation = ({
  fieldPrefix,
  firstName,
  lastName,
  email,
  fellowsArray,
  nonAasRefereesArray,
  errors,
  setError,
  clearErrors,
  enabled = true,
}) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const timer = setTimeout(() => {
      const result = validateExistingRefereeNames(
        firstName,
        lastName,
        email,
        fellowsArray,
        nonAasRefereesArray,
      );
      const nameKey = `${fieldPrefix}Name`;
      const lastNameKey = `${fieldPrefix}LastName`;
      if (result) {
        setError(nameKey, { type: 'info', message: result.message });
        setError(lastNameKey, { type: 'info', message: result.message });
      } else {
        if (errors?.[nameKey]?.type === 'info') clearErrors(nameKey);
        if (errors?.[lastNameKey]?.type === 'info') clearErrors(lastNameKey);
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [
    enabled,
    firstName,
    lastName,
    email,
    fellowsArray,
    nonAasRefereesArray,
    fieldPrefix,
    errors,
    setError,
    clearErrors,
  ]);
};
